import classnames from "classnames";
import { useState } from "react";
import downloadArrow from "../../../../assets/icons/download_arrow.svg";
import { DOWNLOADFILE } from "../../../../global/utility";
import Button from "../../../core/Button/Button";
import CustomImage from "../../../core/CustomImage/CustomImage";
import useModalContext from "../../../core/Modal/useModalContext";
import ContactUsForm from "../../ContactUs/ContactUsForm";
import classes from "../Banner.module.scss";

const CaseStudy = ({
  image,
  title,
  filePath,
  description,
  id,
  className,
  width = 295,
  height = 193,
  buttonLabel = "Download case study",
  backgroundColor = "#B3EAFF",
}) => {
  const modalContext = useModalContext();
  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const downloadCaseStudy = (filePath, title) => {
    const isContactUsFormSubmitted = sessionStorage.getItem(
      "isContactUsFormSubmitted"
    );
    if (isContactUsFormSubmitted) {
      DOWNLOADFILE(filePath, title + ".pdf");
    } else {
      sessionStorage.setItem(
        "selectedCaseStudyInfo",
        JSON.stringify({
          filePath: filePath,
          title: title,
        })
      );
      // let e = document.getElementById("contactUsForm");
      // e.scrollIntoView({
      //   block: "start",
      //   behavior: "smooth",
      //   inline: "center",
      // });
      // toast("Please fill Contact-Us form first.", { autoClose: 3000 });
      modalContext.setBodyWithFooter(
        <ContactUsForm
          closeModal={() => closeModal()}
          className="modalContactForm"
        ></ContactUsForm>
      );
      modalContext.setCloseIconVis(true);
      modalContext.setOnBackdropClick(() => closeModal);
      modalContext.setShow(true);
    }
  };

  const closeModal = () => {
    modalContext.setShow(false);
  };

  const style = {
    container: {
      width: width,
    },
    imageContainer: {
      width: width,
      height: height,
      backgroundColor: backgroundColor,
      position: "relative",
    },
  };
  return (
    <div
      style={style.container}
      className={classnames(className, classes.container)}
      id={id}
    >
      <div style={style.imageContainer}>
        <CustomImage
          src={image}
          alt={title}
          title={title}
          className={classnames("center")}
          divStyle={{ height: "70%" }}
        />
      </div>
      <div className={classes.heading}>{title}</div>
      <div className={classes.subheading}>{description}</div>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <Button
          label={buttonLabel}
          hasBorder={true}
          borderColor={isHover ? "#ffffff" : "#CBD5E1"}
          icon={downloadArrow}
          iconPosition="right"
          backgroundColor={isHover ? "#002970" : "transparent"}
          color={isHover ? "#ffffff" : "#334155"}
          paddingLeft={12}
          paddingRight={12}
          paddingTop={8}
          paddingBottom={8}
          iconWidth={18}
          iconHeight={18}
          clickHandler={() => downloadCaseStudy(filePath, title)}
          styleLabel={{ fontWeight: 400 }}
        />
      </div>
    </div>
  );
};
export default CaseStudy;
